export default __webpack_public_path__ + "media/images/17-ed64021b9331a65e2f9775251eda609f.jpg";